import { PDFDocument, PDFFont, PDFPage, rgb, StandardFonts } from "pdf-lib"
import { FileType, FileTypeForDisplaying } from "../../interfaces/file-type.enum";
import { FormattedDatePipe } from "src/app/shared/pipes/formatted-date/formatted-date.pipe";

export class ReceiveAttachmentSignatureDoc {
    /**
     *
     */
    signatureBuffer = null;
    width = 620;
    height = 840;
    leftMargin = 36;
    bottomMargin = 36;
    topMargin = 36;
    
    constructor(private datePipe: FormattedDatePipe) {}
    
    async get(pharmacyName: string, signature: string, signerName: string, performedDate: Date, recordedDate: Date = new Date(), fileType: FileType, otherType: string, fileName: string): Promise<PDFDocument> {

        if (!this.signatureBuffer) {
            this.signatureBuffer = await fetch('/assets/documents/Sign-Files-portrait.pdf').then((res) => res.arrayBuffer());
        }
        const pdfToAdd = await PDFDocument.load(this.signatureBuffer);
        const pdfDoc = await PDFDocument.create();

        const [copiedPage] = await pdfDoc.copyPages(pdfToAdd, [0]);
        copiedPage.translateContent(this.leftMargin, this.bottomMargin);
        const newHeight = this.height - this.topMargin;
        copiedPage.setSize(this.width, newHeight);

        // Add the copied page to the target PDF
        pdfDoc.addPage(copiedPage);

        const pages = pdfDoc.getPages();
        const lastPage = pages[pages.length - 1];
        const lastPageHeight = lastPage.getSize().height;

        const fontHelvetica = await pdfDoc.embedFont(StandardFonts.Helvetica);
        const fontHelveticaBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

        this.addSubheader(lastPage, fileType, otherType, fileName, fontHelvetica, fontHelveticaBold, pharmacyName);

        const image = await pdfDoc.embedPng(signature);
        lastPage.drawImage(image, {
          x: 5,
          y: lastPageHeight - 300,
          width: 258,
          height: 64,
        });

        lastPage.drawText(signerName, {
          x: 298,
          y: this.height - 330,
          size: 18,
          font: fontHelveticaBold,
        });

        const dateFormat = 'MMM DD, YYYY, HH';
        lastPage.drawText(
          this.datePipe.transform(performedDate, dateFormat),
          {
            x: 10,
            y: this.height - 455,
            size: 16,
            font: fontHelvetica,
          }
        );

        lastPage.drawText(
          this.datePipe.transform(recordedDate, dateFormat),
          {
            x: 298,
            y: this.height - 455,
            size: 16,
            font: fontHelvetica,
          }
        );

        return pdfDoc;

    }   

 private  addSubheader(pdfPage: PDFPage, fileType: FileType, otherType: string, fileName: string, font: PDFFont, fontBold: PDFFont, pharmacyName: string): void {
        const textColor = rgb(31 / 255, 41 / 255, 55/ 255);
        const fileTypeString = fileType !== FileType.Other ? FileTypeForDisplaying[fileType] : otherType;
        let title = fileName;
        title = title.replace('.pdf', '');
        title = title.length > 55 ? title.slice(0, 55) + ' ...' : title;
        pharmacyName = pharmacyName.length > 36 ? pharmacyName.slice(0, 36) + ' ...' : pharmacyName;
    
    
        let currentY = pdfPage.getSize().height - 165;
    
        pdfPage.drawText('This page serves as Proof of Authentication that the ',
          {
            x: 0,
            y: currentY,
            size: 14,
            font: font,
            color: textColor,
          }
        );
    
        pdfPage.drawText(fileTypeString,
           {
             x: 324,
             y: currentY,
             size: 14,
             font: fontBold,
           }
          );
    
          currentY -= 21;
    
          pdfPage.drawText('document titled ',
            {
              x: 0,
              y: currentY,
              size: 14,
              font: font,
              color: textColor,
            }
          );
    
          pdfPage.drawText(title,
            {
              x: 99,
              y: currentY,
              size: 14,
              font: fontBold,
            }
          );
    
          currentY -= 21;
    
          pdfPage.drawText(`for`,
            {
              x: 0,
              y: currentY,
              size: 14,
              font: font,
              color: textColor,
            }
          );
       
          pdfPage.drawText(`${pharmacyName} `,
            {
              x: 20,
              y: currentY,
              size: 14,
              font: fontBold,
            }
          );
    
          let pharmacyNameWidth = fontBold.widthOfTextAtSize(pharmacyName, 14);
          pdfPage.drawText(' has been digitally signed by:',
            {
              x: 20 + pharmacyNameWidth,
              y: currentY,
              size: 14,
              font: font,
              color: textColor,
            }
          );
      }
}